import { ArrowPathIcon, InboxIcon } from "@heroicons/react/24/outline";
import { cx } from "../../utils/cx";

export default function EmptyState({ title = "Nothing here yet", description, onRefresh, className }) {
  return (
    <div className={cx("flex flex-col items-center justify-center gap-2 py-16 text-center", className)}>
      <span className="mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-brand/5">
        <InboxIcon className="h-7 w-7 text-brand/60" />
      </span>
      <p className="text-sm text-slate-500">It's empty here</p>
      <p className="text-lg text-slate-800">{title}</p>
      {description && <p className="max-w-sm text-sm text-slate-500">{description}</p>}
      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          className="mt-2 flex items-center gap-2 rounded-full bg-white px-4 py-3 text-brand shadow-lg shadow-slate-100"
        >
          <ArrowPathIcon className="h-4 w-4" /> Refresh
        </button>
      )}
    </div>
  );
}
